import Checkbox, { CheckboxProps } from 'ext-ui/components/Checkbox/Checkbox'
import Tooltip, { TooltipProps } from 'ext-ui/components/Tooltip/Tooltip'
import React from 'react'

export type CheckboxWithTooltipProps = CheckboxProps & {
  tooltipProps: TooltipProps
}

const CheckboxWithTooltip: React.FC<CheckboxWithTooltipProps> = ({
  tooltipProps,
  ...checkboxProps
}): React.ReactElement => {
  const { enterDelay = 750, ...restTooltipProps } = tooltipProps
  return (
    <Tooltip enterDelay={enterDelay} {...restTooltipProps}>
      <span>
        <Checkbox {...checkboxProps} />
      </span>
    </Tooltip>
  )
}

export default CheckboxWithTooltip
